import apiV2 from '../../api/v2';

/**
 * GP exit from `Hold - 1. Records incomplete` after re-uploading records.
 */
export async function resubmitRecords(patientId: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/hold/records-resubmitted`, {});
}

/**
 * GP exit from `Hold - 5. Clinical question` after answering ODO's clarification ask.
 */
export async function respondToQuestion(patientId: string, response: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/hold/respond-to-question`, { response });
}
